import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { vehicleStatsSchema } from '../schemas/vehicle-stats.schema';

/**
 * Gets all vehicles with unassigned routing profiles in an account
 * @returns Vehicles with unassigned routing profiles
 */
export function getDashboardVehicleStatsUnassignedRoutingProfiles(
  this: unknown
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(
          this
        ).dashboardVehicleStatsUnassignedRoutingProfilesUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(vehicleStatsSchema)));
}
